<template>
  <div class="menu-items-wrapper" v-if="showMenuTripPreferences">
    <div class="menu-items right">
      <PreferencesButton class="menu-item preferences" @click="onPreferencesClick" />
      <SummaryTripInputs
        class="trip-inputs"
        :timeframe="dates"
        :travelers="travelersString"
        :hideOrigin="true"
        :startDate="startDate"
        :endDate="endDate"
        @dates-selected="onDatesUpdate"
        @travelers-click="onTravelersClick"
      />
    </div>
  </div>
</template>

<script>
import PreferencesButton from '@components/common-components/trip-inputs/preferences-button.vue';
import {useSolutionFilters} from '@components/solution-views/summary-filters';
import BookingDialogVue from '@components/summary-page/summary-booking/booking-modal.vue';
import {useSolutionViews} from '@components/solution-views/solution-views';
import SummaryTripInputs from '@components/summary-page/summary-trip-inputs.vue';
import {
  getAllSolutionFilters,
  getStartEndDates,
  getTravelers,
  getTravelersString,
  getTripId,
  rescheduleSolution,
  toggleSolutionTags,
  updateSolutionDates,
  updateSolutionTravelers,
  updateTripPreferences,
  updateTripTravelersInfo,
} from '@/store/state/helpers';
import TravelersFilterModalVue from '@common/travelers-filter/travelers-filter-modal.vue';
import InterestsFilterModalVue from '@common/filter/interest-filter/interest-filter-modal.vue';

import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';

export default {
  name: 'MenuTripPreferences',

  components: {
    SummaryTripInputs,
    PreferencesButton,
  },

  props: {
    pageTitle: {
      type: String,
      default: '',
    },
  },

  setup(_, {root}) {
    const {isLoading, availableContexts, price} = useSolutionViews(root);

    return {
      isLoading,
      availableContexts,
      bookingPrice: price,
    };
  },

  computed: {
    travelers() {
      const {travelersFilter} = useSolutionFilters();
      return travelersFilter.value;
    },
    travelersString() {
      return getTravelersString().join(', ');
    },
    dates() {
      const {timeFrameFilter} = useSolutionFilters();
      return timeFrameFilter.value;
    },
    startDate() {
      return getStartEndDates().start;
    },
    endDate() {
      return getStartEndDates().end;
    },
    showMenuTripPreferences() {
      return getTripId();
    },
  },

  data() {
    return {
      destCity: {
        name: '',
        image: '',
      },
    };
  },

  methods: {
    onBookTripClick() {
      this.$modal.show(BookingDialogVue, {});
    },

    onTravelersClick() {
      const {solutionTravlersFilter} = useSolutionFilters();

      solutionTravlersFilter;
      const travelersModalConfig = {
        get filterValue() {
          return getTravelers();
        },
      };

      this.$modal
        .show(TravelersFilterModalVue, travelersModalConfig)
        .then((updatedTravelers) => {

          if (updatedTravelers) {
            // update travelers info in store
            updateSolutionTravelers(updatedTravelers);

            // update travelers info via API
            updateTripTravelersInfo();
          }
        })
        .catch((e) => {
          console.warn('MenuTripPreferences: Error while changing travelers', e);
        });
    },

    onPreferencesClick() {
      const preferencesModalConfig = {
        get availableTags() {
          return getAllSolutionFilters();
        },

        availableCategories: {
          [UserActivityCategoryEnum.ACCOMMODATION]: true,
          [UserActivityCategoryEnum.DINING]: true,
          [UserActivityCategoryEnum.EXPERIENCE]: true,
        },
      };

      this.$modal
        .show(InterestsFilterModalVue, preferencesModalConfig)
        .then((updatedFilters) => {
          if (updatedFilters) {
            // update travelers info in store
            toggleSolutionTags(updatedFilters);

            // use updateTripPreferences to update problem without re-submittingit again.
            updateTripPreferences();
          }
        })
        .catch((e) => {
          console.warn('MenuTripPreferences: Error while changing filters', e);
        });
    },

    async onDatesUpdate(dateRange) {
      const startDateInMilliseconds = dateRange.startDate.valueOf();
      const endDateInMilliseconds = dateRange.endDate.valueOf();

      // update dates in the store
      updateSolutionDates(startDateInMilliseconds, endDateInMilliseconds);

      // call reschedule API
      await rescheduleSolution(startDateInMilliseconds, endDateInMilliseconds);

      this.$emit('dates-selected', dateRange);
    },
  },
};
</script>

<style scoped>
.menu-items-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 16px;
}

.menu-items.left {
  max-width: 900px;
}

.menu-items.right {
  display: flex;
  gap: 12px;
}

.menu-item {
  height: 40px !important;
}

.trip-inputs {
  margin-top: -5px;
}
</style>

<style>
/* TODO: fix book-btn fot sizes */
.book-btn > button {
  margin: 0 !important;
  height: 40px !important;
  font-weight: 400 !important;
  /* font-size: 16px !important; */
}

.menu-items .input-dates {
  /* flex-basis: 200px !important; */
}

.menu-items .input-travelers {
  /* flex-basis: 250px !important; */
  width: 260px;
}

.menu-items .filtersWrapper {
  justify-content: flex-end !important;
}
</style>
